import React, { useState } from "react";
import DropdownQuestion from "../dropdownQuestion/dropdownQuestion";
import "./singleSelectWithFollowUp.css";

/**
 * SingleSelectWithFollowUp es un componente controlado.
 * - `value` es un array: [opciónPrincipal, respuestaFollowUp?]
 * - `updateProgress` notifica siempre el array completo.
 */
const SingleSelectWithFollowUp = ({
  question,
  options,
  followUp,
  required,
  value = [],
  updateProgress
}) => {
  // Desglosar value
  const selectedOption = value[0] || "";
  const followUpAnswer = value[1] || "";

  const handleOptionChange = option => {
    // Al cambiar la opción principal, reiniciamos followUp
    updateProgress([option]);
  };

  const handleFollowUpChange = answer => {
    // Mantener la opción principal e incluir el follow-up
    updateProgress([selectedOption, answer]);
  };

  return (
    <div className="single-select-follow-up">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <div className="options-container">
        {options.map((opt, idx) => (
          <label key={idx} className="radio-label">
            <input
              type="radio"
              name={`singleSelect-${question}`}
              value={opt}
              checked={selectedOption === opt}
              onChange={() => handleOptionChange(opt)}
            />
            {opt}
          </label>
        ))}
      </div>

      {followUp && selectedOption === followUp.trigger && (
        <div className="follow-up">
          <DropdownQuestion
            question={followUp.question}
            options={followUp.options}
            required={true}
            value={followUpAnswer}
            updateProgress={handleFollowUpChange}
          />
        </div>
      )}
    </div>
  );
};

export default SingleSelectWithFollowUp;